import React from "react";
import styled from "styled-components";

const TickIcon = () => {
  return (
    <Main>
      {" "}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 17 16"
        fill="none"
      >
        <path
          d="M8.50001 14.6667C12.1819 14.6667 15.1667 11.6819 15.1667 8C15.1667 4.3181 12.1819 1.33333 8.50001 1.33333C4.81811 1.33333 1.83334 4.3181 1.83334 8C1.83334 11.6819 4.81811 14.6667 8.50001 14.6667Z"
          stroke="#FEA101"
        />
        <path
          d="M6.16666 8.33333L7.49999 9.66666L10.8333 6.33333"
          stroke="#FEA101"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Main>
  );
};

export default TickIcon;

const Main = styled.div`
  width: 1.6rem;
  height: 1.6rem;
`;
